import React from "react";
import "./About.css";

import CompanyLogo from '../../Asset/Image/PVG_Logo.png'
import { CommonObject } from "../CommonObject";
const About = () => {
  return (
    <section id="About" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-image">
            <img
              // src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&h=400&q=80"
              alt="Business Meeting"
              src={CompanyLogo}
            />
          </div>
          <div className="about-text">
            <h2>About Our Company</h2>
            <p>
              {CommonObject.CompanyName.PVG} is a future-focused enterprise built on a
              simple vision — to connect people and opportunities across
              industries and geographies.With core divisions in Cook-on-Demand,
              Import & Export, and Training & Consultancy, we leverage
              technology, local expertise, and strategic insight to deliver
              meaningful value.
            </p>
            <p>
              Our mission is to create sustainable ventures that empower
              individuals, enable commerce, and elevate communities — from homes
              in the UK to markets around the world.At PVG, we turn ideas into
              enterprises that matter.
            </p>
            <a href="#" className="btn">
              Learn More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
